import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { ToastService } from "src/app/core";
import { AppConfiguration, ConfigurationApi } from "src/app/core/api.gen";
import { LoaderService } from "src/app/core/loader.service";

@Component({
  selector: 'eos-admin-config',
  templateUrl: './admin-config.component.html',
  styleUrls: ['./admin-config.component.css']
})

export class AdminConfigComponent implements OnInit {
  constructor(
    private configApi: ConfigurationApi,
    private toast: ToastService,
    private loader: LoaderService
  ) { }
  form: UntypedFormGroup;
  model: AppConfiguration[] = [];
  ngOnInit() {
    this.form = new UntypedFormGroup({
      disableIC: new UntypedFormControl(''),
      disablePTC: new UntypedFormControl(''),
    });
    this.getAppConfigDetails();
  }
  onUpdate() {
    var configist = this.getAppConfig(this.model);
    this.loader.show();
    this.configApi.setAppConfigValue(configist).pipe(
      finalize(() => this.loader.clear())
    ).subscribe(() => {
      this.toast.success('Configuration updated successfully');
    }, () => { this.toast.error('Failed to update configuration') });
  }
  getAppConfig(model: AppConfiguration[]) {
    var configist:AppConfiguration[] =[];
    model.forEach(x => {
      const config = new AppConfiguration({
        id: x.id,
        configKey: x.configKey,
        configValue: x.configKey === 'IC_AdminConfig' ? this.form.get('disableIC').value : x.configKey === 'PJC_AdminConfig' ? this.form.get('disablePTC').value : null
      });
      configist.push(config);
    }
  );
    return configist;
  }
  getAppConfigDetails() {
    this.loader.show();
    this.configApi.getAppConfigValues('IC_AdminConfig,PJC_AdminConfig').pipe(
      finalize(() => this.loader.clear())
    ).subscribe(resp => {
      this.model = resp;
      this.form.patchValue({
        disableIC: this.model.find(x => x.configKey === 'IC_AdminConfig').configValue=='true' ? true : false,
        disablePTC: this.model.find(x => x.configKey === 'PJC_AdminConfig').configValue=='true' ? true : false
      });
    }, () => { this.toast.error('Something went wrong!') });
  }
}